/** @format */

import { Box, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { scrollToId } from "../../../../Helpers";

function NegativeCoordinates({
  negativeCoordinates,
  handleCloseNegativeDimensionModal,
  pdfPagesRef,
  pdfPages,
  containerRef,
}) {
  console.log("negative coordinates are", negativeCoordinates);
  return (
    <Box sx={{ minWidth: "400px", minHeight: "200px" }}>
      <DialogTitle>Negative Dimension Coordinates</DialogTitle>
      <hr style={{ marginTop: 0 }} />
      <DialogContent>
        <p style={{ fontSize: "12px", marginTop: "0px", width: "400px" }}>
          <span style={{ fontWeight: "bold" }}>Note: </span>&nbsp;The following
          variables have negative dimensions. Remove them and create again.
        </p>
        {negativeCoordinates?.length > 0
          ? negativeCoordinates?.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    border: "1px solid red",
                    padding: "10px",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    scrollToId(
                      `page-${item?.pageNumber}`,
                      pdfPages,
                      containerRef
                    )
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "bold",
                        margin: 0,
                      }}
                    >
                      Page: {item?.pageNumber}
                    </p>
                    <p
                      style={{
                        fontWeight: "bold",
                        margin: 0,
                      }}
                    >
                      Name: {item?.fieldValue || item?.fieldType || item?.value}
                    </p>
                  </div>
                </div>
              );
            })
          : "No Non-Exist Variable"}
      </DialogContent>
    </Box>
  );
}

export default NegativeCoordinates;
